import BaseClass from "./BaseClass";

class DirectoryVendors extends BaseClass {
  static get schema() {
    return {
      name: {
        editable: true,
        props: { sortable: true }
      },
      created_at: {
        props: { sortable: true }
      },
      updated_at: {
        props: { sortable: true }
      }
    };
  }

  get actions() {
    return {
      edit: {
        handler: () => Promise.resolve(this.uuid),
        props: { type: "info", size: "small" },
        in_edit_mode: false
      },
      delete: {
        handler: () => this._handleDelete(),
        props: { type: "danger", size: "small" },
        in_edit_mode: false
      },
      save: {
        handler: () => this._handleSave(),
        props: { type: "success", size: "small", disabled: !this.name },
        in_edit_mode: true
      },
      cancel: {
        handler: () => this._handleCancel(),
        props: { type: "default", size: "small" },
        in_edit_mode: true
      }
    };
  }

  beShownForFilter(filter) {
    return !filter || this.name.toLowerCase().includes(filter.toLowerCase());
  }

  _handleSave() {
    return this._api
      .mutate({
        mutation: require("../../graphql/vendors/vendors_save.graphql"),
        variables: Object.assign({}, this)
      })
      .then(res => {
        Object.assign(this, res.data.directory_vendors);
        return "saved";
      });
  }

  _handleDelete() {
    return this._confirm("Are you sure want to delete this vendor?")
      .then(() => {
        return this._api
          .mutate({
            mutation: require("../../graphql/vendors/vendors_save.graphql"),
            variables: Object.assign({ action: "delete" }, this)
          })
          .then(res => {
            return "deleted";
          });
      })
      .catch(() => {
        return "scipped";
      });
  }

  _handleCancel() {
    if (typeof this.uuid === "undefined") {
      return Promise.reject();
    } else {
      return Promise.resolve("canceled");
    }
  }
}

export default DirectoryVendors;
